import { useEffect } from "react";
import { LoginCta, PrimaryLink } from "./NudgeShared";
import styles from "./Gate.module.scss";
import cx from "classnames";

const Gate = () => {
  useEffect(() => {
    document.body.classList.add(styles.withGate);
    return () => document.body.classList.remove(styles.withGate);
  });

  return (
    <div className={styles.root} data-category="gateway interaction">
      <div className={styles.shadow} />
      <div
        className={styles.container}
        id="gate"
        data-testid="gate"
        aria-labelledby="gate"
        data-action="gateway:display"
        data-label="gate"
      >
        <div className={styles.marginContainer}>
          <div className={styles.gateTextContainer}>
            <p className={cx(styles.gateText, "gate__text")}>
              We hope you&apos;ve enjoyed your free articles.
            </p>
            <div className={styles.loginCta}>
              <LoginCta includeText={true} source="gate" />
            </div>
          </div>

          <div className={styles.gateTitleContainer}>
            <p className={cx(styles.gateTitle, "gate__title")}>
              <span className={styles.gateBreak}>
                Try one month of unlimited digital access.
              </span>{" "}
              Start your free trial today. Cancel anytime.{" "}
            </p>

            <div
              className={cx(styles.spacingContainer, "gate__spacing-container")}
            >
              <PrimaryLink
                text={"Get Started"}
                source={"gate"}
                isExpandedStyles={true}
                isCentered={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gate;
